export enum ClientStatus {
    PROSPECT = 'POTENCIAL',
    PRE_VALIDATED = 'PREVALIDATED',
    VALIDATED = 'VALIDATED',
    CLIENT = 'CLIENT',
    REJECTED = 'REJECTED',
    ERROR = 'ERROR',
    OTHER = '',
}
